export function existeEnArray(valores, buscado) {
  let lista = []
  if (Array.isArray(valores)) lista = valores
  else if (valores != null && typeof valores === 'object') lista = Object.values(valores)
  else lista = [valores]

  if (buscado == null) return '0'
  const needle = String(buscado)

  return lista.some((v) => v != null && String(v) === needle) ? '1' : '0'
}
